import React from 'react';

export function IllustrationCelebration(props) {
  return (
    <svg {...props} viewBox="0 0 621 397" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd" transform="translate(-1)">
        <path
          d="M143.41 100.55c-28.16 23.84-27.73 66.82-56.53 90.81-25.4 21.16-72.66 32.24-83 67.84-17.49 60.27 48.33 88.3 97.88 86.24 62.47-2.59 126.51-58.09 138.3-120.06 9.47-49.78-17.32-120.21-71.29-131.38-10.26-2.09-18.46.71-25.36 6.55z"
          fill="#9973FF"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="M589.88 364.3c.71 5.81-89.86 4.09-99.86 4.13-19.75.08-41.11.35-61.47.08-12.8-.17-49.62 4.22-58.54-4.18a2.77 2.77 0 0 1 2.29-1.26c4.12-1.39 11.86-1.35 16.58-1.61 8.4-.46 16.86-.68 25.3-.86 53.25-1.12 106.76-1.09 160 1.5 3.51.17 7.07.35 10.47.83 1.26.18 5.11.47 5.23 1.37z"
          fill="#9973FF"
          fillRule="nonzero"
          opacity=".2"
        />
        <path
          d="M569.24 212l1.89-2.8s-4.51-8.49-8.87-10.07c0 .03 3.74 10.7 6.98 12.87z"
          fill="#6C12D6"
          fillRule="nonzero"
        />
        <path
          d="M614.66 274.23a3.72 3.72 0 0 1 4.59.54 4.07 4.07 0 0 1 .63 2.31c.09 1.23.25 3.46-.49 4.51-.6.86.78 1.69 1.38.85 1.21-1.72 1-5.35.44-7.25-.86-3.08-4.8-3.82-7.34-2.37a.81.81 0 0 0 .79 1.41z"
          fill="#5C2977"
          fillRule="nonzero"
        />
        <path
          d="M510.3 352.13a9.45 9.45 0 0 1-1.38 8.31c-1.7 2.11-5.23 2.79-6.59-.05-.59-1.26-2.48-.21-1.88 1 1.56 3.26 5.78 3.84 8.59 1.86 3.61-2.55 4.41-7.68 3.35-11.69a1.08 1.08 0 0 0-2.09.53v.04zm12.89.12c.08 3.45.46 6.74 3.17 9.18a8.74 8.74 0 0 0 9.22 2c1.28-.47.77-2.57-.53-2.09a6.82 6.82 0 0 1-7.67-1.89c-1.88-1.93-2-4.6-2-7.14 0-1.38-2.19-1.43-2.16 0l-.03-.06z"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          d="M554.62 352.1c.53 2.51 1.27 5.69-.32 8-1.59 2.31-6.26 2.75-5.57-1.15.18-1-1.37-1.48-1.55-.46a4.13 4.13 0 0 0 5.88 4.63c4.57-2 4-7.35 3.13-11.39-.21-1-1.78-.62-1.57.4v-.03z"
          fill="#5C2977"
          fillRule="nonzero"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d="M182.26 387.92c0 .93-5.39 1.82-12.09 2-6.7.18-12.17-.5-12.17-1.44s5.39-1.82 12.09-2c6.7-.18 12.14.52 12.17 1.44z"
          fill="#9973FF"
          fillRule="nonzero"
          opacity=".3"
        />
        <path
          d="M75 391.34c0 .91-5.1 1.62-11.39 1.6-6.29-.02-11.39-.76-11.39-1.66 0-.9 5.1-1.62 11.39-1.6 6.29.02 11.39.76 11.39 1.66z"
          fill="#9973FF"
          fillRule="nonzero"
          opacity=".3"
        />
        <ellipse
          style={{ mixBlendMode: 'multiply' }}
          cx="112.08"
          cy="386.63"
          fill="#9973FF"
          fillRule="nonzero"
          opacity=".3"
          rx="1.49"
          ry="10.64"
          transform="rotate(-89.84 112.08 386.63)"
        />
        <ellipse
          style={{ mixBlendMode: 'multiply' }}
          cx="226.54"
          cy="389"
          fill="#9973FF"
          fillRule="nonzero"
          opacity=".3"
          rx="12.76"
          ry="1.49"
          transform="rotate(-1.15 226.54 389)"
        />
        <path
          d="M24.37 387.78c0 .82-4.77 1.48-10.64 1.46-5.87-.02-10.65-.7-10.64-1.52.01-.82 4.77-1.47 10.64-1.46 5.87.01 10.65.74 10.64 1.52z"
          fill="#9973FF"
          fillRule="nonzero"
          opacity=".3"
        />
        <path
          d="M200.25 80.88v295.86h-2.02V82.04z"
          fill="#8026E6"
          fillRule="nonzero"
        />
        <path
          d="M193.23 80.13v295.12l5 1.49V82.04z"
          fill="#B5A1FF"
          fillRule="nonzero"
        />
        <path
          d="M199.59 83.2l93.85-18.57v320.34l-93-9.18z"
          fill="#9973FF"
          fillRule="nonzero"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d="M207.6 91.29l73.71-14.23v63.8l-73.71 8.43zm0 276.2l73.71 5.02v-62.34l-73.71-.68z"
          fill="#9973FF"
          fillRule="nonzero"
          opacity=".2"
        />
        <path
          d="M198.23 82.04l56.28-29.55 3.53-10.43-64.81 38.07z"
          fill="#B5A1FF"
          fillRule="nonzero"
        />
        <path
          d="M256.49 50.58l-1.67 5.45-55.23 27.17-1.36-1.16z"
          fill="#8026E6"
          fillRule="nonzero"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d="M207.6 158.59v139.16l31.56.64V155.17zm41.17-2.78v141.94l32.54.76V152.87z"
          fill="#9973FF"
          fillRule="nonzero"
          opacity=".2"
        />
        <path
          d="M212 173.65c1.21.93 12.47 17.83 20.7 22.9 5 3.06 33.51 18 34 18.29.49.29-1.1 4.79-1.57 5.24-.47.45-13.27-1-19.8-2.79a107.69 107.69 0 0 1-16.59-6.59c-2.08-1.17-12.69-11-12.69-11L212 173.65z"
          fill="#FFF"
          fillRule="nonzero"
          stroke="#6C12D6"
          strokeWidth="1.25"
        />
        <path
          d="M300.4 385.9c.52 14.78-64.93 10.41-72.16 10.51-14.07.2-28.15.65-42.23.09a222.39 222.39 0 0 1-28.47-2.81c-3.65-.62-13.7-.17-15.79-6.61-.83-2.57.39-3.06 1.44-4.29 3-3.53 8.57-3.45 12-4.1a159.77 159.77 0 0 1 18.29-2.19c11.47-.84 23-1 34.44-1.07 27.07-.26 54.17.28 81.14 4.89a26.81 26.81 0 0 1 7.56 2.11c.91.46 3.69 1.18 3.78 3.47zm70.41-39.06c.11 4.11-13.21 2.89-14.68 2.92-2.86.06-5.73.18-8.59 0a34.83 34.83 0 0 1-5.8-.78c-.74-.18-2.79-.05-3.21-1.84a1.15 1.15 0 0 1 .29-1.19c.61-1 1.75-1 2.44-1.14a25.08 25.08 0 0 1 3.72-.61c2.33-.23 4.67-.26 7-.29a67.65 67.65 0 0 1 16.51 1.35 4.37 4.37 0 0 1 1.54.59c.2.15.76.36.78.99z"
          fill="#9973FF"
          fillRule="nonzero"
          opacity=".2"
        />
        <path
          d="M159 374.33c-.92 3.53-3.46 9.19 0 12.11 3 2.53 6.94.75 9.53-1.43 1.11-.93-.49-2.52-1.59-1.59-1.92 1.62-6.51 3.61-7.41-.27-.57-2.46 1-5.87 1.6-8.22a1.13 1.13 0 0 0-2.17-.6h.04zm60.64 3.19c.51 3.43.35 9.07 4.14 10.76 3.79 1.69 7.16-1.54 8.74-4.67.65-1.29-1.29-2.43-1.94-1.14-1.23 2.44-5.15 6.38-7.25 2.31-1.18-2.26-1.16-5.39-1.52-7.86-.21-1.43-2.38-.82-2.17.6z"
          fill="#491E4F"
          fillRule="nonzero"
        />
        <path
          d="M204.6 267.39c-1.5 5.41-10.56 45.36-11.52 48.08-.96 2.72-28.52 61.53-29.61 61.85-.93.25-5.68-.83-7.05-1.65-.23-.14-.37-.26-.38-.38-.01-.12.13-.52.36-1.31.51-1.71 1.53-5 2.85-9.14 5.64-17.76 16.8-52.31 17.47-56.3.39-2.27 1-8.7 1.65-15.34.83-9 1.61-18.39 1.61-18.39l24.62-7.42z"
          fill="#FFF"
          fillRule="nonzero"
          stroke="#17E7E2"
          strokeWidth="2"
        />
        <path
          d="M217.07 377.47l-.7-3.71a458.3 458.3 0 0 1-1-5.53 2.24 2.24 0 0 1 0-.28c-3.14-17.2-8.72-44.7-10.13-50.29-1-4-3.9-13.47-6.59-22.09l-1.23-3.92c-2.29-7.32-11.92-32.77-11.92-32.77l27.79-17.64s9.66 66.92 10.12 71.12c.28 2.67 1.86 30.27 2.42 50 .18 6.41-.1 11.75.07 15.36.04 2.67-8.3 2.52-8.83-.25z"
          fill="#FFF"
          fillRule="nonzero"
          stroke="#17E7E2"
          strokeWidth="2"
        />
        <path
          d="M293.44 64.63l6.96.76V384.2l-6.96.77z"
          fill="#8026E6"
          fillRule="nonzero"
        />
        <path
          d="M275.16 217.65a11 11 0 0 0-5.43-2.64h-5.88l-.34.52h-.19l-.05.39-.23.35h.18l-.16 1.3s5.6 3.37 6.66 3.59c1.06.22 5.84-.5 6.21-1.17.37-.67 0-1.6-.77-2.34z"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          d="M286.33 224.23c0 3.23-1 5.85-2.25 5.85s-2.25-2.62-2.25-5.85c0-3.23 1-5.85 2.25-5.85s2.25 2.62 2.25 5.85z"
          fill="#FFF"
          fillRule="nonzero"
        />
        <path
          d="M281.56 220.54l1.91-.32a4 4 0 0 1 0 4.29l-3.23-.25 1.32-3.72z"
          fill="#9973FF"
          fillRule="nonzero"
          opacity=".2"
        />
        <path
          d="M282.39 221.93a5 5 0 0 1-.61 2.44 4.36 4.36 0 0 1-3.84 2.45 4.23 4.23 0 0 1-3.33-1.66 5.07 5.07 0 0 1-1.13-3.23 4.89 4.89 0 0 1 2.89-4.58 4.14 4.14 0 0 1 1.54-.3 4.51 4.51 0 0 1 4.24 3.41c.16.47.24.97.24 1.47z"
          fill="#FFF"
          fillRule="nonzero"
        />
        <path
          d="M215 136.07c.27-4.47-5-7.26-9.44-7.55-8.17-.54-17.25 4.6-18.29 12.72-.46 3.54.58 7.36-1 10.58-3.92 8.23-19.3 4.18-23.09 12.46-1.19 2.6-.72 5.62-.91 8.48-.19 2.86-1.56 6.13-4.37 6.66-2.81.53-5.35-2-8.19-2-4.19-.05-6.53 5-6.44 9.23a20.66 20.66 0 0 0 8.38 16c4.12 3 9.81 4.32 14.39 2.1 8.57-4.14 9.07-17.57 17.6-21.77 4.79-2.35 12.09-2.05 13.51-7.19 1-3.65-.14-7 1.92-10.13 1.29-2 2-3.39 4-4.71 4.74-3.21 4.14-10.4 7.1-15.29 1.33-2.19 3.39-3.9 4.46-6.22 1.07-2.32.63-5.74-1.8-6.54"
          fill="#6C12D6"
          fillRule="nonzero"
        />
        <path
          d="M200.58 151c-.05 2.46 3.28 16.41-10.21 20.07 3.57-.52 6.78 2.05 10.27 3 2 .53 4.08.55 6 1.25 2.34.85.36 2.73 2.85 2.57-1.75-.71 6.22-2.46 5.13-4-5.87-8.25-1-16.57.14-18.79"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          d="M205.6 129.62a4.34 4.34 0 0 0-4.68 1.11 8.87 8.87 0 0 0-2.16 4.6 25.4 25.4 0 0 0-.18 7.93 22.32 22.32 0 0 0 2.26 8.16 11.3 11.3 0 0 0 6.17 5.52 7.47 7.47 0 0 0 7.75-1.82 10 10 0 0 0 2.13-5.61 21.84 21.84 0 0 0-4.54-15.72c-1.88-2.35-4.58-4.41-7.55-4.18"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          d="M211.17 129.32c-3.38-2-7.08-4.17-12.13-1.65a9.8 9.8 0 0 0-6.24 7.79 15.76 15.76 0 0 0 2.13 10.09 34.17 34.17 0 0 0 3.32 5.21 3.4 3.4 0 0 1 2.27-1.77 5.86 5.86 0 0 1 .64-2.54 14.29 14.29 0 0 1 5.54-5.31c3.15-1.87 7.17-3.14 10.41-1.41-.69-3.89-2.56-8.37-5.94-10.41z"
          fill="#6C12D6"
          fillRule="nonzero"
        />
        <path
          d="M201.7 150a2.36 2.36 0 0 0-1.25-2.1c-.68-.4-3.18-.34-3.79.65a3.6 3.6 0 0 0 1.21 5.31 2.86 2.86 0 0 0 3.29-.55 3 3 0 0 0 .54-3.31"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          d="M214.35 142.71h.18a1.45 1.45 0 0 1 1.4 1 .51.51 0 0 1-.3.61.44.44 0 0 1-.55-.33c0-.15-.29-.28-.62-.3a2.06 2.06 0 0 0-1.09.18 1.14 1.14 0 0 0-.58.77.44.44 0 0 1-.51.4.49.49 0 0 1-.36-.57A2.08 2.08 0 0 1 213 143a2.68 2.68 0 0 1 1.35-.29zm-8.13 2.66a2.2 2.2 0 0 1 1.66.84.49.49 0 0 1-.78.59 1.19 1.19 0 0 0-1.31-.39 1.2 1.2 0 0 0-.77 1.12.48.48 0 0 1-.47.5.46.46 0 0 1-.5-.47 2.16 2.16 0 0 1 1.42-2.07c.24-.09.5-.13.75-.12zm4.93 5.2a.51.51 0 0 1-.39-.19.49.49 0 0 1 .08-.68 1.38 1.38 0 0 1 .49-.26l.16-.07.07-.05s-.05 0-.07-.07a13 13 0 0 1-1.88-4.38.49.49 0 0 1 .34-.6.47.47 0 0 1 .6.33 12.25 12.25 0 0 0 1.71 4.05 1.1 1.1 0 0 1 .29.68 1 1 0 0 1-.63.91l-.23.1a1.06 1.06 0 0 0-.24.12.5.5 0 0 1-.3.11zm-36.03 121.91a1.55 1.55 0 0 1 0 .22 1.7 1.7 0 0 0 2.06 1.93c17 1.41 35.54 2.11 49.44-7.76a12.27 12.27 0 0 0 3.5-3.42c2.05-3.36 1.08-7.67 0-11.46-4.68-16.47-10.26-33.14-9.46-50.25.37-7.75 2.05-15.5 1.16-23.21-.4-3.5-1.43-7.11-3.92-9.61-1.45-1.46-2.12-2.53-4-.95-2.78 2.36-2.14 6.67-6.33 6-4.19-.67-11.19-5.1-15-6.75-2.21-1.02-24.25 44.78-17.45 105.26z"
          fill="#6C12D6"
          fillRule="nonzero"
        />
        <path
          d="M192.72 248.14l5.3 6.6c1.33 1.65 1.16 4.48.7 4.65-3.92 1.5-8.61-11-8.61-11l2.61-.25z"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          d="M194.51 248.22c-.29.56-7.34 3.58-7.68 3.15-1.42-1.78-19-40.77-19-43.68 0-2.3 8.63-26.84 19.25-37.57 6.54-6.6 6.95 3.83 6.77 7.12-.18 3.29-12.75 25.28-13.19 26.81-.44 1.53 14.15 43.62 13.85 44.17z"
          fill="#FFF"
          fillRule="nonzero"
          stroke="#6C12D6"
          strokeWidth="1.25"
        />
        <path
          d="M258.04 42.06l8.1 1.04v349.12h-8.1z"
          fill="#8026E6"
          fillRule="nonzero"
        />
        <path
          d="M258.04 42.06v350.16l-4.75-.74-1.69-345.33z"
          fill="#B5A1FF"
          fillRule="nonzero"
        />
        <path
          d="M209.31 153.38a5.19 5.19 0 0 0 5.44-1.42c.46-.43-.23-1.12-.69-.69a4.22 4.22 0 0 1-4.49 1.17c-.6-.21-.86.73-.26.94z"
          fill="#6C12D6"
          fillRule="nonzero"
        />
        <path
          d="M486.92 75.39a5.61 5.61 0 0 0 .59-2.73 1.9 1.9 0 0 0 .13-.56 8.3 8.3 0 0 0 .1-1.73 7.52 7.52 0 0 0-.24-2.75 5.57 5.57 0 0 0-.53-2.23 2.77 2.77 0 0 0-.51-1.38 3.3 3.3 0 0 0-.8-1.67 2.74 2.74 0 0 0-.83-1.38 3.86 3.86 0 0 0-1.06-1.41 2.35 2.35 0 0 1 1-2.37 9.51 9.51 0 0 1 2.93-1.68c.8-.17 1.62-.28 2.41-.51a4.46 4.46 0 0 0 3.38-4.47 3.37 3.37 0 0 0-.74-2.48 2.31 2.31 0 0 0-1-1.15c-.4-.58-1.08-.62-1.67-.83a3 3 0 0 0-.63-.24c-3-.32-5.26 2-5.27 5.44a11.27 11.27 0 0 1-1.18 3.59 8 8 0 0 1-1.73 1.9l-1.07-.33-.83-.51a3.59 3.59 0 0 0-1.68-.85 2.89 2.89 0 0 0-1.6-.58 4.94 4.94 0 0 0-2.5-.57 5.91 5.91 0 0 0-2.83-.23 9.92 9.92 0 0 0-4.14.68 4.61 4.61 0 0 0-2.21.82 14.58 14.58 0 0 0-7.23 6.32 9.52 9.52 0 0 0-1.69 3.58 11.65 11.65 0 0 0-.81 3.82 7.87 7.87 0 0 0 .12 3.38 5.87 5.87 0 0 0 .54 2.77 4.35 4.35 0 0 0 .82 2.2.62.62 0 0 0 .26.56c.02.34.2.66.46.87a4 4 0 0 0 1.1 1.67c.16.45.48.84.89 1.09a4.36 4.36 0 0 0 1.38 1.39 2.36 2.36 0 0 0 1.08.87c.18.3.47.51.81.59a4.4 4.4 0 0 0 1.68 1 3.39 3.39 0 0 0 1.64.67 1 1 0 0 0 .82.29 4.66 4.66 0 0 0 2.23.52h.46c.22.08.46.11.69.1a7.64 7.64 0 0 0 3.33 0 2.7 2.7 0 0 0 1.63-.25 9.53 9.53 0 0 0 3.38-1.1 8.31 8.31 0 0 0 2.64-1.41 16.08 16.08 0 0 0 5.69-7.11 3.13 3.13 0 0 0 .59-1.61zm-17.7-4.84c-.48 0-1-.12-1.44.18a1.91 1.91 0 0 0-.24.34c-.21 1.45-.06 2.9-.13 4.34 0 .58.07 1.2-.44 1.65h-1.34l-1.37-.06c0-.73-.05-1.46-.07-2.19-.02-.73 0-1.66 0-2.49v-6.35a5.84 5.84 0 0 0-.11-2.46c.16-.12.33-.27.43.07l1.1 1.1.82.83 1.32 1.32h.07c.07 0 0 0 0 0L469 68l.82.84c.19.34.47.63.82.82v.07l.21.21h-.06c-.06 0 .14.07.12.18-.44.6-1.11.38-1.72.43h.03zm7.43 5.24c-.12-.62-.75-.74-1.11-1.12a1.43 1.43 0 0 0-.75-.85c-.14-.45-.65-.49-.9-.81a1.25 1.25 0 0 1-.77-.86c-.23-.19-.54-.26-.76-.48-.36-.43-.92-.72-1-1.36a.52.52 0 0 1 .26-.3 2.19 2.19 0 0 1 .83-.16c2.91 0 2.43.09 2.52-2.71a1.78 1.78 0 0 1 .41-1.32c.15-2.32.14-2.32 2.48-2.19l.4.06a.49.49 0 0 0 0-.12l.13.15a.38.38 0 0 0 0 .46V71h.08l-.09.06v.8l-.08 4.44v.5c-.76.03-1.03-.8-1.65-1v-.01zm8.59-6.74a3.36 3.36 0 0 0 .19-.38h.28c-.16.09-.31.25-.47.39v-.01z"
          fill="#9978FF"
          fillRule="nonzero"
        />
        <path
          d="M199.2 155.33a1.47 1.47 0 0 0 0-2.93 1.47 1.47 0 0 0 0 2.93z"
          fill="#FFF"
          fillRule="nonzero"
        />
        <path
          d="M506 137.33a2.37 2.37 0 0 0-3.47.23 2.7 2.7 0 0 0 .44 3.55 3.12 3.12 0 0 0 3.68.14"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          d="M516.77 123.76a5.38 5.38 0 0 1 3 .75c1.92 1.16 2.48 3.43 2.61 5.52a24 24 0 0 1-.84 7.3 20.64 20.64 0 0 1-3.14 7.18 10.46 10.46 0 0 1-6.43 4.23 7.07 7.07 0 0 1-7-2.71 9.19 9.19 0 0 1-1.26-5.43 20 20 0 0 1 4.29-11.82c1.9-2.27 5.45-4.91 8.77-5.02z"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          d="M520.45 140.68a2.36 2.36 0 0 1 3 1.75 2.7 2.7 0 0 1-2 3 3.14 3.14 0 0 1-3.35-1.53m6.56 22.17a7.11 7.11 0 0 1-6-1.51c-4.35-3.19-2.16-12.29-.45-16.82l-7.39.12c-1.2-.31-4.57-1.53-5.76-1.83 0 4.7-1.64 12.66-1.9 15.25-.68 6.69-10.85 5.66-15.16 10.83 9.29-2.13 11.36 12.17 20.88 11.91 3.78-.11 11.84-9 17.39-15a4.2 4.2 0 0 1-1.61-2.95z"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d="M503.33 144.12c.3.3.33-.53.52-.91 0 0 .17-.82.28-1.22a2.61 2.61 0 0 1 1.88-1.67 7.86 7.86 0 0 1 2.61-.11 3.48 3.48 0 0 1 2.38.79 3 3 0 0 1 .61 1.64 11.4 11.4 0 0 1-.08 3.35.47.47 0 0 1-.1.24.51.51 0 0 1-.24.07l-1.3.11.25-1.6a3.92 3.92 0 0 0 .05-1.23 2.12 2.12 0 0 0-1.79-1.58c-.86-.11-2.22-.32-2.86.26-.64.58-.78 2.9-.4 3a3.66 3.66 0 0 0-1.81-1.17"
          fill="#6C12D6"
          fillRule="nonzero"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d="M503.84 141.28c-1.67.92-3 2.29-3.08 4.2a5.55 5.55 0 0 0 2.69 4.76c1.4.7 2.93 1.07 4.49 1.08a17.69 17.69 0 0 0 5.72-.28 7 7 0 0 0 4.52-3.3c.43-.91.72-1.88.87-2.88l.59-3c-.65.16-.91.91-1.28 1.47-.82 1.21-6.16 3-11.66 2.06-2-.32-3.6-3-2.86-4.15"
          fill="#6C12D6"
          fillRule="nonzero"
        />
        <path
          d="M505.52 135.75a2 2 0 0 1 3.44.73.3.3 0 1 1-.56.16 1.39 1.39 0 0 0-2.47-.48c-.23.29-.64-.12-.41-.41zm6.05.9a3 3 0 0 1 4.13 1.7c.11.35-.43.56-.54.2a2.41 2.41 0 0 0-3.39-1.36c-.32.18-.52-.37-.2-.54z"
          fill="#6C12D6"
          fillRule="nonzero"
          stroke="#6C12D6"
          strokeWidth=".25"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d="M555.86 151.93a5.79 5.79 0 0 0-.48-.51 11.86 11.86 0 0 0 1.43-6.71 15.89 15.89 0 0 0-.47-2.55 13.12 13.12 0 0 0-1.3-3.44c-2-3.41-5.62-8.13-9.4-9.1-1.77-.46-6-1-7.7-.17a10.4 10.4 0 0 0-6.9 3.35c-2.53 3-3 8.23-2.12 12.09 1.37 5.64 6.46 9.69 11.9 11.5a19.72 19.72 0 0 0 2.18.61 9 9 0 0 0 1.47 7.56 6.66 6.66 0 0 0 5.11 2.82 7.86 7.86 0 0 0 3.21-.78 10.32 10.32 0 0 0 4-3c2.5-3.37 1.85-8.53-.93-11.67z"
          fill="#6C12D6"
          fillRule="nonzero"
        />
        <path
          d="M540.16 261.78c.41 26.25 10.88 95.52 16.3 92.39 2.76.17 3.58-44.32 3.45-48.19a565.13 565.13 0 0 0-3.13-42.82m2.53-1.27c3.43 12.29 6.91 24.65 11.94 36.38 5.36 12.47 20.26-.21 24.55-4.28 4.79-4.55 9.83-10.48 14.63-15 2.24-2.13 5.48-4.14 6-6.13a6.54 6.54 0 0 0-5.6-.11A162.26 162.26 0 0 0 585.4 285a3.4 3.4 0 0 1-2.34.76c-1.35-.26-1.81-1.91-2-3.27l-4.59-31.17m-37.73-120.67a3.73 3.73 0 0 1 4.21.12 7.92 7.92 0 0 1 2.67 3.64 23.6 23.6 0 0 1 1.56 6.92 20.65 20.65 0 0 1-.49 7.56 10.08 10.08 0 0 1-4.32 6 6.4 6.4 0 0 1-7-.19 8.89 8.89 0 0 1-2.82-4.53 19.91 19.91 0 0 1 1.11-14.6c1.19-2.4 3.14-4.7 5.73-5"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          d="M547.29 144.23a2.22 2.22 0 0 1 3.19.59 2.52 2.52 0 0 1-.8 3.25 2.92 2.92 0 0 1-3.43-.27m-.09 2.55c.92 5 2.19 10.22 4 12.52 2.39 3 6.55 4.34 9.81 4.7a1.57 1.57 0 0 1 1.14 2.42c-3.33 5.1-8.32 13.35-12 14.35-8.61 2.3-13.58-10.25-21.56-6.31 2.8-5.63 10.09-6.84 11.13-13 .34-2.05-3-8.05-5-12.33"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          d="M538.62 165.85a7.14 7.14 0 0 0 12.94-2.57 79.62 79.62 0 0 1 12.17 2.2c.54 10.22.3 34.46.64 36.31 1 5.19 27.07 41.47 29.29 44.48-3.23 4.87-8.31 8.2-13.54 10.81a79.67 79.67 0 0 1-45.59 7.65 2.75 2.75 0 0 1-1.43-.48 2.8 2.8 0 0 1-.74-1.6 192.51 192.51 0 0 1-4-48.06c.47-11.2 1.93-22.48.25-33.56-.68-4.46-1.86-9-1.11-13.44a35.33 35.33 0 0 1 10.9-1.61"
          fill="#9973FF"
          fillRule="nonzero"
        />
        <path
          d="M511.34 253.28c2.21 23.57 5.82 43.9 6.81 67.56.33 7.81 1.14 21.29 2.94 28.9.52 2.21 1.19 2.87 3.45 3.07 2.26.2 4.94-37.53 5.3-44.65.21-4.07.58-12 .78-16.09.2-3.9-.62-31.51 0-42.07l-17.73 5.41M492.54 248c-5.1 11.38-8.71 26.51-12.08 38.52a20.81 20.81 0 0 0-1.1 7.52 21.32 21.32 0 0 0 2.67 7.4c8.52 16.64 16.61 32.9 25.92 49.12.73 1.27 3.57 2.67 4.59 1.62.61-.62.25-1.61.1-2.47-3.9-21.76-9.81-39.49-17.61-50.66a5 5 0 0 1-.68-3 8.58 8.58 0 0 1 1.44-3.88c6.38-11.45 13-30.83 14.63-43.83"
          fill="#491E4F"
          fillRule="nonzero"
        />
        <path
          d="M532.5 133.68a7 7 0 0 0-.65 2.51 5.82 5.82 0 0 0 1.41 4.27c1.35 1.36 3.44 1.55 5.34 1.82a32.32 32.32 0 0 1 7.95 2.23c.23.13.49.18.75.17.4-.05.67-.44.84-.81a8.16 8.16 0 0 0 .57-2.78c.2-2.54.13-5.28-1.32-7.38-1-1.51-1.8-3.13-3.58-3.59-1.78-.46-2.19-.88-4-.58a18 18 0 0 0-7.31 4.14c-.06.08 0-.09 0 0a1.73 1.73 0 0 0-.13-.4"
          fill="#6C12D6"
          fillRule="nonzero"
        />
        <path
          d="M551.67 163.72l3.56.38-.28-.29c-.35 5.09-5.2 7.62-9.53 8.95l.34.2a26.26 26.26 0 0 0-.91-3.8c-.08-.24-.48-.3-.54 0a23.33 23.33 0 0 1-.62 2.32c-.2.6-.25 1.21-1.07 1.28-.4 0-1-.41-1.33-.58-1.48-.75-5.55-4.56-6.62-5.82-.23-.27-.64.12-.4.39 1.41 1.67 6.08 5.87 8.19 6.54.61.2.87.3 1.25-.22a11.36 11.36 0 0 0 1.14-3.75h-.54a29.17 29.17 0 0 1 .91 3.8.28.28 0 0 0 .34.2c4.59-1.41 9.59-4.12 10-9.48a.27.27 0 0 0-.27-.28l-3.56-.38c-.36 0-.37.52 0 .56l-.06-.02z"
          fill="#D9C2F7"
          fillRule="nonzero"
        />
        <path
          d="M533 146c.28-1.32 1.81-.83 2.36 0 .2.3.69 0 .49-.27a2.23 2.23 0 0 0-1.92-1.1 1.59 1.59 0 0 0-1.47 1.24c-.07.35.46.51.54.16V146zm6.16-.44a1.39 1.39 0 0 1 2.71 0 .28.28 0 0 0 .54-.14 2 2 0 0 0-3.79 0c-.09.35.45.51.54.16v-.02z"
          fill="#6C12D6"
          fillRule="nonzero"
          stroke="#6C12D6"
          strokeWidth=".25"
        />
        <path
          d="M570 208.44a2.06 2.06 0 0 0-.6-.58 2.18 2.18 0 0 0-.54-.65 1.28 1.28 0 0 0-2.2.57 8 8 0 0 0 0 5 2.63 2.63 0 0 0 1.73 1.95c1.11.29 2.16-.57 2.47-1.93a5.72 5.72 0 0 0-.86-4.36z"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          d="M406.12 349.36c.37 2.81.73 5.75-.28 8.39-1.01 2.64-3.86 4.82-6.58 4m41.49-6.6a6.26 6.26 0 0 0 8.1 6.64"
          stroke="#5C2977"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          d="M402.7 156.81c-2-.53-4.21-1.14-5.55-2.76-1.34-1.62-1.23-4.57.71-5.37 1.54-.64 3.92 0 4.49-1.55a2.34 2.34 0 0 0 0-1.26c-.86-4.05-5.44-7-4.92-11.14a5.05 5.05 0 0 1 6.78-3.76c1.33.62 2.31 1.79 3.52 2.61 1.21.82 3 1.2 4.06.2a3.81 3.81 0 0 0 .91-1.66c.48-1.42.89-3 2-3.93 1.11-.93 3.33-.76 3.7.69a7.76 7.76 0 0 1 0 1.67c0 .56.27 1.21.82 1.31a1.5 1.5 0 0 0 1.09-.37c1.24-.83 2.41-1.75 3.7-2.49a10.1 10.1 0 0 1 7.09-1.35 6.16 6.16 0 0 1 4.83 5 7.17 7.17 0 0 1-1.8 5.17 40.35 40.35 0 0 1-4 3.9 2.38 2.38 0 0 0-.73 1c-.32 1 .68 1.95 1.69 2.23a19.23 19.23 0 0 1 3.05.66 2.94 2.94 0 0 1-.07 5.36c-.79.35-1.78.39-2.31 1.07a2.13 2.13 0 0 0 .39 2.61c.63.71 1.51 1.17 2.19 1.85a4.75 4.75 0 1 1-6.43 7 9.8 9.8 0 0 0-2-1.71c-1.48-.68-3.21.3-4.29 1.53s-1.85 2.75-3.19 3.68a2.76 2.76 0 0 1-2.17.54c-1.9-.45-2-3.11-3-4.77a41.79 41.79 0 0 1-7.14 1.66 5.23 5.23 0 0 1-2.78-.15 2 2 0 0 1-1.21-2.27c.23-.45.54-.85.91-1.19a3.06 3.06 0 0 0 .76-2.09c.01-1.08.09-1.27-1.1-1.92z"
          fill="#491E4F"
          fillRule="nonzero"
        />
        <path
          d="M396.85 245.2c1.8 21.3 2.63 38.44 3.34 59.8.23 7.05 3.37 38.7 4.93 45.59.29 1.26 1.47 3.67 3.22 2.56 1.75-1.11 1.41-8.39 1.56-10.25.37-4.92.61-9.85.84-14.79.36-7.88.44-13.63.91-21.51.22-3.67 5.9-56 6.52-65.55-5.34 1.57-13.7.39-19.05 2m22.82-72.73c-2.77-2.84-5-8-3.93-11.94a15.88 15.88 0 0 1 2-3.86 2.61 2.61 0 0 0 2.63.48 2.28 2.28 0 0 0 1.28-2.74 2 2 0 0 0-2.68-1.1c.2-.96.35-1.93.44-2.9a20.13 20.13 0 0 0-.21-6.2 6.93 6.93 0 0 0-1.76-3.57 3.46 3.46 0 0 0-3.7-.85c-2.09.13-4 1.61-5.29 3.29a16.78 16.78 0 0 0-3.44 12.29c.78 6.39 2.34 12-3.23 16.64-2.19 1.83-5.65 2.31-8.32 3-6.46 1.57 41.2 10.14 40.62 9.44-2.04-2.47-1.59 1.14-14.41-11.98z"
          fill="#FFF"
          fillRule="nonzero"
          stroke="#00E7E3"
        />
        <path
          d="M412.79 247.47c5.48 20.65 16.6 50.75 21 71.66 1.45 6.91 1.51 28.68 4.25 35.19.79 1.88 1.49 2.37 3.53 2.21 2.04-.16 1.47-44 .73-50.42-.42-3.66-6.06-56.85-7.1-66.33-5 2.48-15.58 2.66-20.57 5.14M398.8 179c-22.3-11.15-34.93-43.95-36.16-46.75-.77-1.74.45-8.4-1.81-8.72-7.67-1.08 4.06 29 5.95 32.85 6.48 13.34 16.92 28 30.24 35.36 1.32-3.1 1.23-2 2.05-5.28m34.18-1.16c24.22-5.91 43.83-35.08 45.65-37.54 1.14-1.53 1.43-8.29 3.7-8.1 7.72.65-10.4 27.35-13.1 30.71-9.29 11.56-22.72 23.55-37.34 27.75-.6-3.31-.76-2.23-.83-5.6"
          fill="#FFF"
          fillRule="nonzero"
          stroke="#00E7E3"
        />
        <path
          d="M395.16 171.74c14.27 5.38 26.5 9.72 41.75 9.4a255.56 255.56 0 0 1 4.09 97.75c-16.13-.72-32.24 3-46-5.58a7.94 7.94 0 0 1-2.49-2.11 8.48 8.48 0 0 1-1-4.52c-.27-5.95-8.32-70.2 3.68-94.94"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d="M406.06 148.42c.89-1.14 2-2.49 3.61-2.53 1.61-.04 3.14 1.29 4.53.6.9-.44 1.25-1.53 2-2.24a2.88 2.88 0 0 1 2.92-.64c.53.19 1 .53 1.53.68 1.58.43 3.2-1.15 3.24-2.79a5 5 0 0 0-2.43-4 9.28 9.28 0 0 0-7.63-1.15s-8.32 1.09-7.77 12.07z"
          fill="#491E4F"
          fillRule="nonzero"
        />
        <path
          d="M391.79 200.18a431.3 431.3 0 0 1 12.71-14.35l-.46-.2c.44 7.33.52 14.67.25 22l.42-.22a67 67 0 0 0-13.36-7.41c-.32-.14-.47.38-.15.52a66.13 66.13 0 0 1 13.22 7.32.28.28 0 0 0 .42-.23 234 234 0 0 0-.25-22c0-.21-.29-.39-.46-.2a402.97 402.97 0 0 0-12.72 14.35c-.22.26.15.66.38.39v.03zm29.96-19.79a123.91 123.91 0 0 1 4.49 12.4.27.27 0 0 0 .49.07l7.11-11.54a.27.27 0 0 0-.46-.29l-7.11 11.55.49.08a126.66 126.66 0 0 0-4.53-12.54c-.14-.32-.61-.05-.48.27zm19.16 22.06a269.74 269.74 0 0 1-17.65 10.85.27.27 0 0 0 .06.49l19.57 8.55c.32.14.47-.38.16-.52l-19.58-8.55.06.5c6-3.4 11.88-7.01 17.64-10.85.29-.19 0-.67-.26-.47zm-38.26 29.89c2.19-3 4.54-6 6.92-8.86l3.44-4.15c.2-.24.58-.94 1-.91.16 0 .57.57.69.69a26 26 0 0 1 1.82 2.23c2.15 2.93 4 6.08 6 9.13l6.26 9.71.32-.4a180.36 180.36 0 0 1-26.57-7.84c-.33-.12-.48.4-.16.52a180.72 180.72 0 0 0 26.57 7.84c.21 0 .45-.17.32-.39l-7.8-12.07c-2.25-3.49-4.33-7.27-7.4-10.13a.28.28 0 0 0-.39 0c-3.87 4.73-7.88 9.37-11.45 14.35-.21.28.26.57.46.28h-.03zm-7.51 25.33a208.3 208.3 0 0 1 6.64-12.17h-.42c5.35 6.79 9.69 14.28 14 21.76l.31-.4a259.97 259.97 0 0 1-20.59-9.26c-.31-.15-.59.31-.28.47a263.39 263.39 0 0 0 20.71 9.31.27.27 0 0 0 .32-.39c-4.33-7.51-8.7-15-14.08-21.86a.27.27 0 0 0-.43 0c-2.35 4-4.56 8.06-6.64 12.18-.16.31.31.59.46.28v.08zm48.42-11.86a161.27 161.27 0 0 1-17 12.05.27.27 0 0 0 .06.49l16 5.22a.27.27 0 1 0 .16-.52l-16-5.22.06.5a161.92 161.92 0 0 0 17.08-12.13c.27-.22-.11-.61-.38-.39h.02zm-25.22-95.17a1.69 1.69 0 0 0-1.36-1.48 2.4 2.4 0 0 0-2.18.86c-.23.26.12.67.36.41a2 2 0 0 1 1.43-.75 1.16 1.16 0 0 1 1.22 1.07c0 .35.57.24.53-.11zm-6.44-.64a1.79 1.79 0 0 0-1.53-1.47c-.65-.1-1.91.1-2.08.88-.07.34.44.52.51.18.11-.5 1.13-.57 1.5-.51.54.06.97.47 1.06 1 .06.34.59.24.54-.11v.03z"
          fill="#6C12D6"
          fillRule="nonzero"
          stroke="#6C12D6"
          strokeWidth=".25"
        />
        <path
          d="M446.2 127.74a51.21 51.21 0 0 1-3.64-5.1 2.93 2.93 0 0 0-.9-1 1.41 1.41 0 0 0-2 .43 3 3 0 0 0 .17 2 41.36 41.36 0 0 0 1.76 4.44"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d="M447.26 126.46a28.45 28.45 0 0 1-6.19 1.26c6.64 16.23 28.42 41.11 46.13 49.81a24.38 24.38 0 0 0 5.55-12l.5-1.46c-15.36-5.25-36.71-25.27-45.99-37.61z"
          fill="#6C12D6"
          fillRule="nonzero"
        />
        <path
          d="M413.09 149.74a24.39 24.39 0 0 1-1.62 3.66.41.41 0 0 0 .23.6l1.47.26c.51.08.74-.69.23-.78l-1.47-.26.23.6a27 27 0 0 0 1.71-3.85c.17-.49-.6-.72-.78-.23zm-1.56 6.26a3 3 0 0 0 3.43.33c.45-.26.06-1-.39-.71a2.14 2.14 0 0 1-2.46-.18c-.4-.33-1 .23-.58.56zm125.18-11.18a86.1 86.1 0 0 0 0 5.33.41.41 0 0 0 .51.4c.41-.12 1.89-.22 2.3-.34.41-.12.31-.93-.19-.78-.5.15-1.9.22-2.31.34l.5.4a67.67 67.67 0 0 1 0-5.33.41.41 0 0 0-.81 0v-.02zm2.29 8.38a2.57 2.57 0 0 0 3.1-1.84c.13-.5-.66-.68-.79-.18a1.76 1.76 0 0 1-2.13 1.23c-.5-.13-.68.66-.18.79z"
          fill="#6C12D6"
          fillRule="nonzero"
        />
        <path
          d="M564.79 59.29l-1.19-3.45 6.39-6.64 5.13 3.45z"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          d="M475.75 9.29l2.35-.17-.66-9.12-3.4.17z"
          fill="#6C12D6"
          fillRule="nonzero"
        />
        <path
          d="M407.34 23.76l5.6 9.38-1.62.6-7.69-9.45z"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          d="M542.47 38.13l5.66-8.27L549.8 31l-5.66 8.27zm-108.36-8.96l1.71-1.07 4.14 6.6-.73 1.26z"
          fill="#9973FF"
          fillRule="nonzero"
        />
        <path
          d="M378.84 56.48l.92-1.8 8.04 4.14-.92 1.8zm12.44 320.3l5.74-2.69-2.04-.71-7.75 1.72z"
          fill="#D9C2F7"
          fillRule="nonzero"
        />
        <circle
          cx="520.25"
          cy="21.66"
          fill="#D9C2F7"
          fillRule="nonzero"
          r="2.89"
        />
        <path
          d="M459 28.75a.91.91 0 0 1-.5-.15l-1.25-.84a4.56 4.56 0 0 1-2-3.78v-3.05a2.8 2.8 0 0 0-1.43-2.44 4.55 4.55 0 0 1-2.27-4.8l.37-2a2.77 2.77 0 0 0-1.42-2.95l-1.62-.88a4.57 4.57 0 0 1-2.18-5.37l.21-.64a.88.88 0 1 1 1.68.52l-.2.65a2.78 2.78 0 0 0 1.33 3.28l1.63.89a4.54 4.54 0 0 1 2.33 4.81l-.37 2a2.77 2.77 0 0 0 1.39 2.94 4.58 4.58 0 0 1 2.34 4V24c0 .93.46 1.8 1.23 2.31l1.25.84a.89.89 0 0 1-.49 1.62l-.03-.02z"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          d="M501.39 22.81a.65.65 0 0 1-.59-.33.63.63 0 0 1 .26-.86l.78-.42a1.53 1.53 0 0 0 .8-1.19l.19-1.79a2.77 2.77 0 0 1 1.68-2.28 1.54 1.54 0 0 0 .92-1.53l-.1-1.2a2.8 2.8 0 0 1 1.72-2.8l1-.42a1.53 1.53 0 0 0 .95-1.72l-.08-.39a.63.63 0 1 1 1.24-.25l.08.39a2.8 2.8 0 0 1-1.66 3.14l-1 .41a1.55 1.55 0 0 0-.94 1.54l.1 1.2A2.79 2.79 0 0 1 505 17.1a1.54 1.54 0 0 0-.92 1.25l-.18 1.79a2.81 2.81 0 0 1-1.46 2.18l-.79.41a.61.61 0 0 1-.26.08zm8.85 28.85l-.66-.81a3 3 0 0 0 1-1.56 4.49 4.49 0 0 1-2.41-.29 2.29 2.29 0 0 1-1.17-1.41 2.78 2.78 0 0 1 .09-2.11 1.75 1.75 0 0 1 2.35-.57 3.79 3.79 0 0 1 2.29 3 3 3 0 0 0 2-2.66 6.94 6.94 0 0 1-2.94-1 2.29 2.29 0 0 1-1-2.14 1.45 1.45 0 0 1 1.21-1.06c1.56-.32 3 .77 3.57 2.65 0 .18.09.36.13.55a2.14 2.14 0 0 0 2.14-1.89 6.18 6.18 0 0 0 0-1.43 5.17 5.17 0 0 1-1.9.17 2.47 2.47 0 0 1-2.19-1.72 1.89 1.89 0 0 1 1.25-2.15 2.72 2.72 0 0 1 2.48.56c.58.43 1 1.03 1.21 1.72a2.33 2.33 0 0 0 1-.84 4.46 4.46 0 0 0 0-3v-.16l1-.21v.15a5.23 5.23 0 0 1-.12 3.71 3.38 3.38 0 0 1-1.63 1.4 7.54 7.54 0 0 1 0 1.93 3.2 3.2 0 0 1-3.13 2.81 4 4 0 0 1-2.68 3.62l-.37.13a4 4 0 0 1-1.52 2.61zm-1.79-5.91a.5.5 0 0 0-.45.25 1.67 1.67 0 0 0 0 1.29c.1.34.34.63.66.78a3.62 3.62 0 0 0 2 .16v-.16a2.73 2.73 0 0 0-1.66-2.19 1.65 1.65 0 0 0-.55-.13zm3.1-3.71a1.24 1.24 0 0 0-.33 0c-.4.08-.44.25-.45.31 0 .43.23.83.59 1.07a5.47 5.47 0 0 0 2.27.75l-.06-.22c-.28-.95-1.02-1.95-2.02-1.95v.04zm3.1-3.89a.81.81 0 0 0-.31.06.83.83 0 0 0-.54.92 1.48 1.48 0 0 0 1.29.93 4.43 4.43 0 0 0 1.58-.16 2.43 2.43 0 0 0-.84-1.25 2.12 2.12 0 0 0-1.18-.5z"
          fill="#6C12D6"
          fillRule="nonzero"
        />
        <path
          d="M597.09 365.92l-3.43 1.08 4.33 2.85 5.31-2.36z"
          fill="#9973FF"
          fillRule="nonzero"
        />
        <path
          d="M530.33 373.34l2.58 2.4 5.37-.39-6.09-2.01zm-161.4-3.66a12.62 12.62 0 0 1-2.53 0c-1.77-.2-2.58-.75-1.8-1.21a5.44 5.44 0 0 1 2.09-.5 13.4 13.4 0 0 1 2.53 0c1.77.21 2.58.75 1.8 1.22a5.63 5.63 0 0 1-2.09.5"
          fill="#6C12D6"
          fillRule="nonzero"
        />
        <path
          d="M420.36 376a10.1 10.1 0 0 1-2 0c-1.39-.16-2-.58-1.41-.95a4.3 4.3 0 0 1 1.63-.39 10.22 10.22 0 0 1 2 0c1.38.16 2 .58 1.4.95a4.3 4.3 0 0 1-1.63.39"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          d="M575 374.2a17.59 17.59 0 0 1-3 0c-2.1-.21-3-.76-2.13-1.24a7.38 7.38 0 0 1 2.47-.5 17.6 17.6 0 0 1 3 0c2.1.21 3 .76 2.12 1.24a7.31 7.31 0 0 1-2.46.5"
          fill="#9973FF"
          fillRule="nonzero"
          opacity=".2"
        />
        <circle
          cx="539.41"
          cy="70.8"
          fill="#9973FF"
          fillRule="nonzero"
          r="2.36"
        />
        <circle
          cx="426.46"
          cy="54.69"
          fill="#9973FF"
          fillRule="nonzero"
          r="2.36"
        />
        <path
          d="M517.59 161.13s-.36-5.13-1.81-6.38c0 0-7.45-.24-11.24-.32a13.34 13.34 0 0 0-1.54 5.64c-6.07.94-7.13 1.82-13.71 2.13-8.52 4.66-10.78 80-5.08 88.2 3.68 5.31 29.82 11.33 47.25 1 5.76-6.61.79-42.48-.19-50.65-.41-3.39-2.48-29-3.36-34-6.54-1.93-3.65-4.2-10.32-5.62"
          fill="#6C12D6"
          fillRule="nonzero"
        />
        <path
          d="M547.87 186.62a25.65 25.65 0 0 1-2.64 1.43c-4.14 1.94-8.75 2.6-13.29 3.16-4.54.56-9.5.85-13-2a18.37 18.37 0 0 0-3.27-2.67c-3.59-1.73-3.24 1.31-2 3.3 1.24 1.99 3.62 3.28 5.51 4.29a38.12 38.12 0 0 0 14.32 4.1 34.46 34.46 0 0 0 22.5-6.05 25.61 25.61 0 0 0 9.55-11.84 17.07 17.07 0 0 0-1.26-14.85c-4.2 7.97-8.9 16.42-16.42 21.13z"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          d="M530.65 191.22c1.39-1.58 2.5 3.31 2.57 4a9.39 9.39 0 0 1 0 2.31 3 3 0 0 1-.37 1.17c-.42.64-1.4 1.15-2 .2a.2.2 0 0 0-.35.19 1.41 1.41 0 0 0 2.2.32c1-.83 1-2.51.93-3.69a9 9 0 0 0-1.25-4.39c-.47-.69-1.39-1.13-2-.4-.17.19.1.48.27.29z"
          fill="#F7F7F8"
          fillRule="nonzero"
        />
        <path
          d="M482.68 244.93c6.94 5.15 16 6.84 24.3 7a84.84 84.84 0 0 0 13.41-.93 69.89 69.89 0 0 0 13.41-3.65c.32-.12.19-.66-.13-.55a69.46 69.46 0 0 1-12.43 3.51 84.37 84.37 0 0 1-13.74 1.07c-8.34-.08-17.54-1.71-24.54-6.91-.28-.2-.55.28-.28.48v-.02z"
          fill="#D9C2F7"
          fillRule="nonzero"
        />
        <path
          d="M494.18 158.09a12.29 12.29 0 0 0-3.53.84 2.59 2.59 0 0 0-1.31.95 2.3 2.3 0 0 0-.24 1.3c.11 2 1.27 3.87 2.41 5.57.2.4.53.71.92.92.93.38 1.85-.58 2.33-1.47a13.67 13.67 0 0 0 1.59-5.22 3.37 3.37 0 0 0-.39-2.3 1.39 1.39 0 0 0-2-.31"
          fill="#00E7E3"
          fillRule="nonzero"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d="M369.66 289.32c1.79-4.05 2.66-8.48 1.45-12.81-1.42-5.05-5.47-10.81-11.18-11.11-3.91-.21-7.45 3.45-8 7.37-.63 4.22 1.91 6.9 3.32 10.47a6.66 6.66 0 0 1-.43 5.86c-3.54 6.46-.46 14.89-2.07 19.16a21.91 21.91 0 0 0-1.37 4.6 10.7 10.7 0 0 0 3.19 9.09h9.84a13.06 13.06 0 0 0 1.19-2.93 12.87 12.87 0 0 0-1-9.06c-2.19-4.21-3.23-6.53-.93-11 1.71-3.34 4.45-6.17 5.99-9.64z"
          fill="#9973FF"
          fillRule="nonzero"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d="M351.36 312.86a21.91 21.91 0 0 1 1.37-4.6c1.61-4.27 3-8.71 3-13.27a18.15 18.15 0 0 0-1-5.89 13.26 13.26 0 0 0-4.28-6.25 8.23 8.23 0 0 0-4.08-1.77c-2.76-.3-5.41 1.25-7.36 3.21-2.85 2.84-4.68 7.37-2.77 10.92 1.1 2 3.2 3.33 4.6 5.18a9.14 9.14 0 0 1 .9 9.34c-.74 1.5-1.89 2.79-2.5 4.35-1.12 2.89 1.09 6.15 3.67 7.87h11.57a10.7 10.7 0 0 1-3.12-9.09z"
          fill="#6C12D6"
          fillRule="nonzero"
        />
        <path
          d="M364.55 322.69c-1.56-2.15-7.81-.74-9.86-.74-2.46 0-5.93.07-8.39.07-3.47 0-4.29-.71-4 3a154.84 154.84 0 0 0 2.7 16.33c.37 1.94.76 4.74 2.72 5.87 2.8 1.61 8.93.5 12 .27 2.7-.2 1.89-3.36 2.13-5.26.61-4.86 2-9.74 2.65-14.59a20.85 20.85 0 0 0 .5-3.64 2.44 2.44 0 0 0-.45-1.31z"
          fill="#FFF"
          fillRule="nonzero"
          stroke="#00E7E3"
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components-legacy/SVG/IllustrationCelebration.js